import { render, staticRenderFns } from "./ManageCoaches.vue?vue&type=template&id=02127fa0&scoped=true&"
import script from "./ManageCoaches.vue?vue&type=script&lang=js&"
export * from "./ManageCoaches.vue?vue&type=script&lang=js&"
import style0 from "./ManageCoaches.vue?vue&type=style&index=0&id=02127fa0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02127fa0",
  null
  
)

export default component.exports